import { useState } from 'react';
import { ABOUT_PHOTO_SRC } from '../config/media';

function AboutIntro() {
  const [photoError, setPhotoError] = useState(false);

  return (
    <section className="bg-white px-5 py-12 md:px-10 md:py-20">
      <div className="mx-auto flex max-w-5xl flex-col gap-8 md:flex-row md:items-center md:gap-20">
        <div className="flex w-full justify-center md:w-auto md:shrink-0">
          <div className="h-72 w-72 overflow-hidden rounded-full bg-neutral-200 md:h-80 md:w-80">
            {photoError ? (
              <div className="flex h-full w-full items-center justify-center bg-neutral-200 text-neutral-400">
                <span className="font-serif text-5xl uppercase tracking-widest">И</span>
              </div>
            ) : (
              <img
                src={ABOUT_PHOTO_SRC}
                alt="Иделия"
                className="h-full w-full object-cover grayscale"
                onError={() => setPhotoError(true)}
              />
            )}
          </div>
        </div>

        <div className="w-full text-left">
          <p className="mb-6 text-xl font-light leading-snug text-neutral-400 md:mb-8 md:text-[1.75rem] md:leading-snug">
            Привет! Меня зовут Иделия, рада видеть тебя на моем сайте!
          </p>
          <p className="mb-4 text-sm leading-relaxed text-neutral-600 md:text-[0.9375rem]">
            Я коммерческий фотограф в Москве. Провожу свадебные, репортажные, а также индивидуальные
            съемки.
          </p>
          <p className="m-0 text-sm leading-relaxed text-neutral-600 md:text-[0.9375rem]">
            Занимаюсь фотографией более 5 лет, провела большое количество съемок, чтобы достичь
            успешного результата. Я фотографирую на профессиональную и дорогую технику, поэтому
            ручаюсь за качество своих работ.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutIntro;
